/**
 * @generated SignedSource<<476a19479721a00870fd591357293494>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSort = "ID" | "EXTERNAL_REF" | "ACCOUNT_ID" | "USER_ID" | "NAME" | "DESCRIPTION" | "LOCATION" | "BEGINS_AT" | "ENDS_AT" | "RECURRING" | "RECURRING_BEGIN" | "RECURRING_END" | "ICALENDAR" | "TIME_ZONE" | "COMMENT" | "FLAG" | "TYPE" | "STATUS" | "ZOOM_MEETING_DETAILS" | "TAGS" | "CREATED_BY" | "DELETED_AT" | "UPDATED_AT" | "CREATED_AT" | "SOURCE" | "SESSION_TYPE" | "GOOGLE_MEET_DETAILS" | "INCOMPLETE_TYPE" | "INCOMPLETE_REASON" | "CANCELLATION_TYPE" | "CANCELLATION_REASON" | "CANCELLATION_DATETIME" | "PRACTITIONER_CONFIRMATION_DATETIME" | "PRACTITIONER_CONFIRMATION_SOURCE" | "MEET_COMPLETION_DETAIL" | "ZOOM_COMPLETION_DETAIL" | "TWILIO_COMPLETION_DETAIL" | "COMPLETED_DATETIME" | "CANCELLATION_REASON_TYPE" | "UPDATED_BY" | "RANDOM" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type EventOrdering = {
  sort: EventSort;
  direction: SortDirection;
};
export type EventFilter = {
  search?: string | null;
  where?: EventWhere | null;
  awaitingConfirmationOnly?: boolean | null;
};
export type EventWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  userId?: IDFilter | null;
  name?: StringFilter | null;
  description?: StringFilter | null;
  location?: StringFilter | null;
  beginsAt?: TimeFilter | null;
  endsAt?: TimeFilter | null;
  recurring?: BooleanFilter | null;
  recurringBegin?: TimeFilter | null;
  recurringEnd?: TimeFilter | null;
  icalendar?: StringFilter | null;
  timeZone?: StringFilter | null;
  comment?: StringFilter | null;
  flag?: StringFilter | null;
  type?: StringFilter | null;
  status?: StringFilter | null;
  zoomMeetingDetails?: any | null;
  tags?: StringFilter | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  source?: StringFilter | null;
  sessionType?: StringFilter | null;
  googleMeetDetails?: any | null;
  incompleteType?: StringFilter | null;
  incompleteReason?: StringFilter | null;
  cancellationType?: StringFilter | null;
  cancellationReason?: StringFilter | null;
  cancellationDatetime?: TimeFilter | null;
  practitionerConfirmationDatetime?: TimeFilter | null;
  practitionerConfirmationSource?: StringFilter | null;
  meetCompletionDetail?: any | null;
  zoomCompletionDetail?: any | null;
  twilioCompletionDetail?: any | null;
  completedDatetime?: TimeFilter | null;
  cancellationReasonType?: StringFilter | null;
  updatedBy?: StringFilter | null;
  session?: SessionWhere | null;
  eventGuests?: EventGuestWhere | null;
  eventRequests?: EventRequestWhere | null;
  or?: EventWhere | null;
  and?: EventWhere | null;
  practitionerCountry?: StringFilter | null;
  practitionerCountryID?: IDFilter | null;
  practitionerEmail?: StringFilter | null;
  practitionerFirstName?: StringFilter | null;
  practitionerLastName?: StringFilter | null;
  practitionerTalkProvider?: StringFilter | null;
  clientOrganisation?: StringFilter | null;
};
export type IDFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
};
export type StringFilter = {
  isNullOrEmpty?: boolean | null;
  isEmpty?: boolean | null;
  isNull?: boolean | null;
  notNullOrEmpty?: boolean | null;
  notEmpty?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
  startWith?: string | null;
  notStartWith?: string | null;
  endWith?: string | null;
  notEndWith?: string | null;
  contain?: string | null;
  notContain?: string | null;
  startWithStrict?: string | null;
  notStartWithStrict?: string | null;
  endWithStrict?: string | null;
  notEndWithStrict?: string | null;
  containStrict?: string | null;
  notContainStrict?: string | null;
};
export type TimeFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: any | null;
  notEqualTo?: any | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  moreThan?: any | null;
  moreThanOrEqualTo?: any | null;
};
export type BooleanFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: boolean | null;
  notEqualTo?: boolean | null;
};
export type SessionWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  createdBy?: IDFilter | null;
  password?: StringFilter | null;
  status?: StringFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  events?: EventWhere | null;
  sessionHistories?: SessionHistoryWhere | null;
  or?: SessionWhere | null;
  and?: SessionWhere | null;
};
export type SessionHistoryWhere = {
  id?: IDFilter | null;
  duration?: FloatFilter | null;
  userId?: IDFilter | null;
  startAt?: TimeFilter | null;
  endAt?: TimeFilter | null;
  iP?: StringFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  session?: SessionWhere | null;
  or?: SessionHistoryWhere | null;
  and?: SessionHistoryWhere | null;
};
export type FloatFilter = {
  isNullOrZero?: boolean | null;
  isNull?: boolean | null;
  notNullOrZero?: boolean | null;
  notNull?: boolean | null;
  equalTo?: number | null;
  notEqualTo?: number | null;
  lessThan?: number | null;
  lessThanOrEqualTo?: number | null;
  moreThan?: number | null;
  moreThanOrEqualTo?: number | null;
  in?: ReadonlyArray<number> | null;
  notIn?: ReadonlyArray<number> | null;
};
export type EventGuestWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  status?: StringFilter | null;
  recurringSendSalesOrder?: BooleanFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  event?: EventWhere | null;
  salesOrders?: SalesOrderWhere | null;
  or?: EventGuestWhere | null;
  and?: EventGuestWhere | null;
};
export type ContactWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  email?: StringFilter | null;
  salutation?: StringFilter | null;
  firstName?: StringFilter | null;
  lastName?: StringFilter | null;
  preferredName?: StringFilter | null;
  dob?: TimeFilter | null;
  gender?: StringFilter | null;
  mobilePhone?: StringFilter | null;
  workPhone?: StringFilter | null;
  homePhone?: StringFilter | null;
  addressLineOne?: StringFilter | null;
  addressLineTwo?: StringFilter | null;
  city?: StringFilter | null;
  state?: StringFilter | null;
  countryId?: IDFilter | null;
  zip?: StringFilter | null;
  status?: StringFilter | null;
  type?: StringFilter | null;
  businessName?: StringFilter | null;
  occupation?: StringFilter | null;
  source?: StringFilter | null;
  meta?: any | null;
  workflowStatus?: any | null;
  photoUrls?: any | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  userId?: IDFilter | null;
  unmindUserId?: StringFilter | null;
  timezone?: StringFilter | null;
  locale?: StringFilter | null;
  contactAccountId?: IDFilter | null;
  sessionLimitOverride?: IntFilter | null;
  accountContacts?: AccountContactWhere | null;
  contactActivityHistories?: ContactActivityHistoryWhere | null;
  contactNotes?: ContactNoteWhere | null;
  contactTags?: ContactTagWhere | null;
  contactTeamMembers?: ContactTeamMemberWhere | null;
  eventGuests?: EventGuestWhere | null;
  eventRequests?: EventRequestWhere | null;
  formResponses?: FormResponseWhere | null;
  salesOrders?: SalesOrderWhere | null;
  or?: ContactWhere | null;
  and?: ContactWhere | null;
};
export type IntFilter = {
  isNullOrZero?: boolean | null;
  isNull?: boolean | null;
  notNullOrZero?: boolean | null;
  notNull?: boolean | null;
  equalTo?: number | null;
  notEqualTo?: number | null;
  lessThan?: number | null;
  lessThanOrEqualTo?: number | null;
  moreThan?: number | null;
  moreThanOrEqualTo?: number | null;
  in?: ReadonlyArray<number> | null;
  notIn?: ReadonlyArray<number> | null;
};
export type AccountContactWhere = {
  id?: IDFilter | null;
  accountId?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  or?: AccountContactWhere | null;
  and?: AccountContactWhere | null;
};
export type ContactActivityHistoryWhere = {
  id?: IDFilter | null;
  type?: StringFilter | null;
  description?: StringFilter | null;
  meta?: any | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  or?: ContactActivityHistoryWhere | null;
  and?: ContactActivityHistoryWhere | null;
};
export type ContactNoteWhere = {
  id?: IDFilter | null;
  message?: StringFilter | null;
  attachments?: any | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  or?: ContactNoteWhere | null;
  and?: ContactNoteWhere | null;
};
export type ContactTagWhere = {
  id?: IDFilter | null;
  accountId?: IDFilter | null;
  tag?: StringFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  or?: ContactTagWhere | null;
  and?: ContactTagWhere | null;
};
export type ContactTeamMemberWhere = {
  id?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  fee?: FeeWhere | null;
  teamMember?: TeamMemberWhere | null;
  or?: ContactTeamMemberWhere | null;
  and?: ContactTeamMemberWhere | null;
};
export type FeeWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  name?: StringFilter | null;
  description?: StringFilter | null;
  amount?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  meta?: any | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  type?: StringFilter | null;
  contactTeamMembers?: ContactTeamMemberWhere | null;
  teamMembers?: TeamMemberWhere | null;
  or?: FeeWhere | null;
  and?: FeeWhere | null;
};
export type TeamMemberWhere = {
  id?: IDFilter | null;
  accountId?: IDFilter | null;
  memberUserId?: IDFilter | null;
  permissions?: any | null;
  showOnCatalogue?: BooleanFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  fee?: FeeWhere | null;
  channelMembers?: ChannelMemberWhere | null;
  contactTeamMembers?: ContactTeamMemberWhere | null;
  or?: TeamMemberWhere | null;
  and?: TeamMemberWhere | null;
};
export type ChannelMemberWhere = {
  id?: IDFilter | null;
  allowCustomProduct?: BooleanFilter | null;
  productMeta?: any | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  status?: StringFilter | null;
  isVisible?: TimeFilter | null;
  channel?: ChannelWhere | null;
  teamMember?: TeamMemberWhere | null;
  or?: ChannelMemberWhere | null;
  and?: ChannelMemberWhere | null;
};
export type ChannelWhere = {
  id?: IDFilter | null;
  name?: StringFilter | null;
  logo?: StringFilter | null;
  accountId?: IDFilter | null;
  public?: BooleanFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  channelMembers?: ChannelMemberWhere | null;
  channelMemberProducts?: ChannelMemberProductWhere | null;
  or?: ChannelWhere | null;
  and?: ChannelWhere | null;
};
export type ChannelMemberProductWhere = {
  id?: IDFilter | null;
  userProfileId?: IDFilter | null;
  name?: StringFilter | null;
  description?: StringFilter | null;
  internalPrice?: FloatFilter | null;
  internalCurrency?: StringFilter | null;
  externalPrice?: FloatFilter | null;
  externalCurrency?: StringFilter | null;
  meta?: any | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  channel?: ChannelWhere | null;
  or?: ChannelMemberProductWhere | null;
  and?: ChannelMemberProductWhere | null;
};
export type EventRequestWhere = {
  id?: IDFilter | null;
  accountId?: IDFilter | null;
  preferredUserId?: IDFilter | null;
  contactMethod?: StringFilter | null;
  comment?: StringFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  accountInvoiceId?: IDFilter | null;
  declinationReason?: StringFilter | null;
  contact?: ContactWhere | null;
  event?: EventWhere | null;
  salesOrders?: SalesOrderWhere | null;
  or?: EventRequestWhere | null;
  and?: EventRequestWhere | null;
};
export type SalesOrderWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  userId?: IDFilter | null;
  customerEmail?: StringFilter | null;
  customerFirstName?: StringFilter | null;
  customerLastName?: StringFilter | null;
  subAmount?: FloatFilter | null;
  taxAmount?: FloatFilter | null;
  totalAmount?: FloatFilter | null;
  discountAmount?: FloatFilter | null;
  grandAmount?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  status?: StringFilter | null;
  meta?: any | null;
  paymentTerms?: any | null;
  eventRecurringId?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  accountInvoiceId?: IDFilter | null;
  type?: StringFilter | null;
  updatedBy?: StringFilter | null;
  contact?: ContactWhere | null;
  eventGuest?: EventGuestWhere | null;
  eventRequest?: EventRequestWhere | null;
  payment?: PaymentWhere | null;
  paymentIns?: PaymentInWhere | null;
  paymentOuts?: PaymentOutWhere | null;
  salesOrderItems?: SalesOrderItemWhere | null;
  or?: SalesOrderWhere | null;
  and?: SalesOrderWhere | null;
};
export type PaymentWhere = {
  id?: IDFilter | null;
  paidAt?: TimeFilter | null;
  amount?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  accountId?: IDFilter | null;
  createdAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  deletedAt?: TimeFilter | null;
  salesOrders?: SalesOrderWhere | null;
  or?: PaymentWhere | null;
  and?: PaymentWhere | null;
};
export type PaymentInWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  ref?: StringFilter | null;
  amount?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  payerEmail?: StringFilter | null;
  meta?: any | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  salesOrder?: SalesOrderWhere | null;
  paymentOuts?: PaymentOutWhere | null;
  or?: PaymentInWhere | null;
  and?: PaymentInWhere | null;
};
export type PaymentOutWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  ref?: StringFilter | null;
  accountId?: IDFilter | null;
  amount?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  meta?: any | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  status?: StringFilter | null;
  source?: StringFilter | null;
  paymentIn?: PaymentInWhere | null;
  salesOrder?: SalesOrderWhere | null;
  or?: PaymentOutWhere | null;
  and?: PaymentOutWhere | null;
};
export type SalesOrderItemWhere = {
  id?: IDFilter | null;
  name?: StringFilter | null;
  description?: StringFilter | null;
  quantity?: IntFilter | null;
  price?: FloatFilter | null;
  discount?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  meta?: any | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  product?: ProductWhere | null;
  salesOrder?: SalesOrderWhere | null;
  or?: SalesOrderItemWhere | null;
  and?: SalesOrderItemWhere | null;
};
export type ProductWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  name?: StringFilter | null;
  description?: StringFilter | null;
  type?: StringFilter | null;
  price?: FloatFilter | null;
  currencyCode?: StringFilter | null;
  meta?: any | null;
  createdBy?: IDFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  salesOrderItems?: SalesOrderItemWhere | null;
  or?: ProductWhere | null;
  and?: ProductWhere | null;
};
export type FormResponseWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  schema?: any | null;
  uISchema?: any | null;
  formData?: any | null;
  createdAt?: TimeFilter | null;
  deletedAt?: TimeFilter | null;
  contact?: ContactWhere | null;
  form?: FormWhere | null;
  or?: FormResponseWhere | null;
  and?: FormResponseWhere | null;
};
export type FormWhere = {
  id?: IDFilter | null;
  externalRef?: StringFilter | null;
  accountId?: IDFilter | null;
  name?: StringFilter | null;
  schema?: any | null;
  uISchema?: any | null;
  submitText?: StringFilter | null;
  thankYouMessage?: StringFilter | null;
  captchaEnabled?: BooleanFilter | null;
  isPublished?: BooleanFilter | null;
  noBranding?: BooleanFilter | null;
  notificationRecipients?: any | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  type?: FormTypeWhere | null;
  formResponses?: FormResponseWhere | null;
  or?: FormWhere | null;
  and?: FormWhere | null;
};
export type FormTypeWhere = {
  id?: IDFilter | null;
  description?: StringFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  typeForms?: FormWhere | null;
  or?: FormTypeWhere | null;
  and?: FormTypeWhere | null;
};
export type eventsQuery$variables = {
  first: number;
  after?: string | null;
  ordering?: ReadonlyArray<EventOrdering> | null;
  filter?: EventFilter | null;
  skip: boolean;
};
export type eventsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"eventsFragment">;
};
export type eventsQuery = {
  variables: eventsQuery$variables;
  response: eventsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ordering"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ordering",
    "variableName": "ordering"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v24 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionResponse",
    "storageKey": null
  }
],
v25 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "eventsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "eventsFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "eventsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "location",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "beginsAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endsAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recurring",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdBy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "comment",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icalendar",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recurrenceID",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalStartTime",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventGuest",
                        "kind": "LinkedField",
                        "name": "eventGuests",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assessmentStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contact",
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v13/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unmindUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SessionLimitPayload",
                                "kind": "LinkedField",
                                "name": "sessionLimits",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sessionLimitType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amountRemaining",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expiryDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrder",
                            "kind": "LinkedField",
                            "name": "salesOrders",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v18/*: any*/),
                              (v9/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerEmail",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerFirstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerLastName",
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalAmount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "grandAmount",
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "eventRecurringId",
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Payment",
                                "kind": "LinkedField",
                                "name": "payment",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "paidAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amount",
                                    "storageKey": null
                                  },
                                  (v19/*: any*/),
                                  (v9/*: any*/),
                                  (v15/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderItem",
                                "kind": "LinkedField",
                                "name": "salesOrderItems",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "quantity",
                                    "storageKey": null
                                  },
                                  (v23/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "discount",
                                    "storageKey": null
                                  },
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v18/*: any*/),
                                      (v9/*: any*/),
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      (v23/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventGuestAssessmentResponses",
                            "kind": "LinkedField",
                            "name": "eventGuestAssessmentResponses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventGuestAssessmentResponse",
                                "kind": "LinkedField",
                                "name": "GAD",
                                "plural": true,
                                "selections": (v24/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventGuestAssessmentResponse",
                                "kind": "LinkedField",
                                "name": "PHQ",
                                "plural": true,
                                "selections": (v24/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventGuestAssessmentResponse",
                                "kind": "LinkedField",
                                "name": "Workplace",
                                "plural": true,
                                "selections": (v24/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "submittedAt",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "userProfile",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "countryId",
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "photoUrls",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "languages",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "setupComplete",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "googleCredentials",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "gender",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ethnicity",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "createdByUserProfile",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomMeetingDetails",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sessionType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleMeetDetails",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "completedDatetime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cancellationReasonType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "practitionerConfirmationDatetime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": [
              "ordering",
              "filter"
            ],
            "handle": "connection",
            "key": "connection_events",
            "kind": "LinkedHandle",
            "name": "events"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0b465598bb12b321888017be57d7548f",
    "id": null,
    "metadata": {},
    "name": "eventsQuery",
    "operationKind": "query",
    "text": "query eventsQuery(\n  $first: Int!\n  $after: String\n  $ordering: [EventOrdering!]\n  $filter: EventFilter\n  $skip: Boolean!\n) {\n  ...eventsFragment\n}\n\nfragment contactBaseInlineFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  userId\n  unmindUserId\n  ...contactSessionLimitsRemainingInlineFragment\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment eventGuestAssessmentResponsesInlineFragment on EventGuestAssessmentResponses {\n  GAD {\n    id\n    questionId\n    questionResponse\n  }\n  PHQ {\n    id\n    questionId\n    questionResponse\n  }\n  Workplace {\n    id\n    questionId\n    questionResponse\n  }\n  submittedAt\n}\n\nfragment eventGuestInlineFragment on EventGuest {\n  id\n  status\n  assessmentStatus\n  contact {\n    ...contactBaseInlineFragment\n    id\n  }\n  salesOrders {\n    ...salesOrderBaseInlineFragment\n    salesOrderItems {\n      ...salesOrderItemInlineFragment\n      id\n    }\n    id\n  }\n  eventGuestAssessmentResponses {\n    ...eventGuestAssessmentResponsesInlineFragment\n  }\n}\n\nfragment eventInlineFragment on Event {\n  id\n  name\n  userId\n  accountId\n  description\n  location\n  beginsAt\n  endsAt\n  recurring\n  timeZone\n  type\n  source\n  createdBy\n  comment\n  status\n  icalendar\n  recurrenceID\n  originalStartTime\n  createdAt\n  eventGuests {\n    ...eventGuestInlineFragment\n    id\n  }\n  userProfile {\n    ...userProfileBaseFragment\n    ...userProfileNameFragment\n    ...userProfileBaseInlineFragment\n    ...userProfileNameInlineFragment\n    id\n  }\n  createdByUserProfile {\n    ...userProfileNameInlineFragment\n    id\n  }\n  zoomMeetingDetails\n  sessionType\n  googleMeetDetails\n  completedDatetime\n  cancellationReasonType\n  practitionerConfirmationDatetime\n}\n\nfragment eventsFragment on Query {\n  events(first: $first, after: $after, ordering: $ordering, filter: $filter) @skip(if: $skip) {\n    count\n    edges {\n      node {\n        ...eventInlineFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment paymentBaseInlineFragment on Payment {\n  id\n  paidAt\n  amount\n  currencyCode\n  accountId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment productFragment on Product {\n  id\n  externalRef\n  accountId\n  name\n  description\n  type\n  price\n  currencyCode\n  meta\n  createdAt\n}\n\nfragment salesOrderBaseInlineFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  totalAmount\n  grandAmount\n  currencyCode\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n  payment {\n    ...paymentBaseInlineFragment\n    id\n  }\n}\n\nfragment salesOrderItemInlineFragment on SalesOrderItem {\n  id\n  name\n  description\n  quantity\n  price\n  discount\n  currencyCode\n  meta\n  product {\n    ...productFragment\n    id\n  }\n}\n\nfragment userProfileBaseFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n  phone\n  languages\n  setupComplete\n  googleCredentials\n  gender\n  ethnicity\n}\n\nfragment userProfileBaseInlineFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n}\n\nfragment userProfileNameFragment on UserProfile {\n  firstName\n  lastName\n}\n\nfragment userProfileNameInlineFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "8caf1b63164a16b52cfabf7f726c1792";

export default node;
